export const getPersistedFormData = <T extends {}>(storage: Storage, itemKey: string) => {
  const sessionData = storage.getItem(itemKey);

  if (sessionData) {
    const data: any = {};
    const sessionDataValue = JSON.parse(sessionData);
    Object.keys(sessionDataValue).forEach((key) => {
      switch (key) {
        case "chosenDate":
          let start: any = new Date(sessionDataValue[key].start);
          let end: any = new Date(sessionDataValue[key].end);
          start = isNaN(start.getTime()) ? "" : start;
          end = isNaN(end.getTime()) ? "" : end;
          data[key] = { start, end };
          break;

        default:
          data[key] = sessionDataValue[key];
      }
    });
    return data as T;
  }
};

export const persistFormData = <T>(storage: Storage, itemKey: string, data: T) => {
  storage.setItem(itemKey, JSON.stringify(data));
};
